<template>
    <div class="box">
        <div class="title">
            <!--<div class="build" @click="buildingClick">-->
            <div class="build">
                {{checkTreeData.name}}
                <!--<i class="el-icon-caret-bottom"></i>-->
                <div :class="buildShow?'building_list':'building_list building_list_hide'">
                    <p v-for="(item,index) in treeDatas" :key="index" @click="buildClick(item)">{{item.name}}</p>
                </div>
            </div>
            <div class="date">{{nowTime[0]}} {{nowTime[2]}}</div>
        </div>
        <div class="tip">
            <div class="tip-title">宿舍用水用电一览表</div>
            <div class="now-time">
                <div class="text">当前时间:</div>
                <div class="time">{{nowTime[1]}}</div>
            </div>
        </div>
        <div class="content" ref="muContent">
            <el-empty v-if="datas.length==0">
                <p slot="description" class="tip">未配置数据</p>
            </el-empty>
            <div class="middle-body" ref="middleBody">
                <div class="body" ref="myBody">
                    <div :class="['dormitory',item.bgclass]" v-for="(item,index) in datas" :key="index">
                        <div class="name">{{item.name}}</div>
                        <div :class="['bgtip',item.colorClass]" v-if="item.type==1">3天</div>
                        <div :class="['bgtip',item.colorClass]" v-if="item.type==2">停机</div>
                        <div :class="['bgtip',item.colorClass]" v-if="item.type==3">欠费</div>
                        <div class="inform">
                            <div>余额:{{item.amount}}</div>
                            <div>电:{{item.readInfo?item.readInfo.value:'0'}}度</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "electricityUse",
        data() {
            return {
                buildingId: '',
                nowTime: [],
                query: {
                    schoolId: '',
                    openid: 'abc',
                },
                treeDatas: [],
                datas: [],
                buildShow: false,
                checkTreeData: {},

                timeScroll: null,
                stepPx: 0,
            }
        },
        created() {
            this.query.schoolId = this.$route.query.schoolId
            this.buildingId = this.$route.query.buildingId
            this.nowTimes()
            this.getTree()
        },
        methods: {
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = [];
                this.nowTime.push(year + "年" + month + "月" + date + '日');
                this.nowTime.push(hh + ":" + mm + ':' + ss);
                let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                this.nowTime.push(weeks[timeStamp.getDay()]);
            },

            // 寝室楼
            getTree() {
                let _this = this
                let url = "/zuhu1/api-dashboard/building/tree3"
                let query = {
                    purpose: 3,
                    schoolId: _this.query.schoolId,
                    openid: 'abc',
                }
                this.$api.post(url, query, response => {
                    let datas = response.data.data || []
                    _this.treeDatas = datas
                    _this.checkTreeData = datas[0] || []
                    datas.map(item => {
                        if (item.buildingId == _this.buildingId) {
                            _this.checkTreeData = item
                        }
                    })
                    _this.getData()
                })
            },
            getData() {
                let _this = this
                let url = "/zuhu1/api-dashboard/building/waterElectric"
                let query = {
                    schoolId: _this.query.schoolId,
                    openid: 'abc',
                    inDay: 1,
                    purpose: 3,
                    treeBuildingId: this.checkTreeData.buildingId || ''
                }
                this.$api.post(url, query, response => {
                    let datas = response.data.data || []
                    datas.map(item => {
                        if(item.amount < 30){
                            item.type = 4
                            item.bgclass = 'bgclass4'
                            item.colorClass = 'colorClass4'
                        }
                        if (item.arrearsRemind1) {
                            item.type = item.arrearsRemind1.type
                            item.bgclass = 'bgclass' + item.arrearsRemind1.type
                            item.colorClass = 'colorClass' + item.arrearsRemind1.type
                        }
                        if (item.arrearsRemind2) {
                            item.type = item.arrearsRemind2.type
                            item.bgclass = 'bgclass' + item.arrearsRemind2.type
                            item.colorClass = 'colorClass' + item.arrearsRemind2.type
                        }
                        if (item.arrearsRemind3) {
                            item.type = item.arrearsRemind3.type
                            item.bgclass = 'bgclass' + item.arrearsRemind3.type
                            item.colorClass = 'colorClass' + item.arrearsRemind3.type
                        }
                    })
                    datas.sort(function(a, b) {
                        let numA = (a.name.match(/\d+/) || ['0'])[0];
                        let numB = (b.name.match(/\d+/) || ['0'])[0];
                        return parseInt(numA, 10) - parseInt(numB, 10);
                    });
                    _this.datas = datas
                    _this.getHeight()
                })
            },

            buildingClick() {
                this.buildShow = !this.buildShow
            },
            buildClick(item) {
                this.checkTreeData = item
                this.getData()
            },

            getHeight() {
                let _this = this
                this.$nextTick(() => {
                    const contentHeight = this.$refs.muContent.offsetHeight;
                    const bodyHeight = this.$refs.myBody.offsetHeight;
                    this.$refs.middleBody.style.height= bodyHeight+'px'
                    setTimeout(function () {
                        if (bodyHeight > contentHeight) {
                            _this.divScroll(bodyHeight, contentHeight)
                            _this.datas=[..._this.datas,..._this.datas]
                        }
                    },500)

                });
            },
            divScroll(bodyHeight, contentHeight) {
                let _this = this
                this.clearTimer()

                this.timeScroll = setInterval(() => {
                    if (this.stepPx < bodyHeight) {
                        _this.$refs.myBody.style.top = -_this.stepPx + 'px'
                        _this.stepPx += 1  // 1为每次移动的px值
                    } else if (_this.stepPx === bodyHeight) {
                        _this.stepPx = 0
                    }
                }, 100) // 50为移动的速度
            },
            clearTimer() {
                clearInterval(this.timeScroll)
            },
        }
    }
</script>

<style scoped>
    .box {
        background: #8DC0FC;
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
    }

    .title {
        background: #245C9A;
        width: 98%;
        margin: 5px auto;
        height: 100px;
        color: white;
        position: relative;
        text-align: center;
        z-index: 10;
    }

    .build {
        display: inline-block;
        height: 100px;
        line-height: 100px;
        font-size: 36px;
        min-width: 400px;
        cursor: pointer;
        z-index: 10;
    }

    .building_list {
        padding: 20px;
        box-sizing: border-box;
        background: rgba(51, 153, 204, 0.95);
        border: 2px solid rgba(153, 204, 255, 1);
        border-top: 0;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        transition: 0.3s;
    }

    .building_list p {
        font-style: normal;
        font-size: 32px;
        color: #fff;
        padding: 3px 0;
        line-height: 50px;
    }

    .building_list p:hover {
        background: #336699;
    }


    .building_list_hide {
        height: 0 !important;
        padding: 0 !important;
        border: none !important;
        overflow: hidden;
    }

    .date {
        position: absolute;
        top: 0;
        right: 40px;
        height: 100px;
        line-height: 100px;
        font-size: 28px;
    }

    .tip {
        height: 80px;
        display: flex;
        justify-content: space-between;
    }

    .tip-title {
        height: 80px;
        line-height: 80px;
        font-size: 36px;
        padding: 0 40px;
        color: black;
    }

    .now-time {
        color: #225A98;
        display: flex;
        padding: 0 40px;
    }

    .now-time > div {
        height: 80px;
        line-height: 80px;
        font-size: 28px;
    }

    .text {
        color: black;
        padding: 0 10px;
    }

    .time {
        font-size: 36px !important;
    }

    .content {
        flex: 1;
        overflow: auto;
    }

    .body {
        width: 96%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        position: relative;

    }

    .content::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background: #8DC0FC;
    }

    .content::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: rgb(9, 52, 94);
    }

    .dormitory {
        width: 290px;
        height: 130px;
        background: #245C9A;
        color: white;
        position: relative;
        margin: 5px 4px;
    }

    .name {
        text-align: center;
        font-size: 24px;
        padding: 15px 0;
    }

    .inform {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px;
        box-sizing: border-box;
        font-size: 18px;
    }

    .bgclass1 {
        background: #FFE171;
    }

    .bgclass2 {
        background: #888181;
    }

    .bgclass3 {
        background: #ff1813;
    }
    .bgclass4 {
        background: #ED7D31;
    }

    .colorClass1 {
        color: #FFE171;
    }

    .colorClass2 {
        color: #888181;
    }

    .colorClass3 {
        color: #ff1813;
    }

    .bgtip {
        position: absolute;
        top: 5px;
        right: 5px;
        border-radius: 50%;
        background: white;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
    }

    .tip {
        color: white;
    }

    .middle-body{
        overflow: hidden;
    }

</style>
